import { render } from "./UserCenterChangeTranslateLog.vue?vue&type=template&id=5f2ef228&scoped=true"
import script from "./UserCenterChangeTranslateLog.vue?vue&type=script&lang=js"
export * from "./UserCenterChangeTranslateLog.vue?vue&type=script&lang=js"

import "./UserCenterChangeTranslateLog.vue?vue&type=style&index=0&id=5f2ef228&lang=scss&scoped=true"

import exportComponent from "D:\\work\\code\\tranWorld\\traneasy-reply(易回复官网)\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f2ef228"]])

export default __exports__